import React from 'react'

function AuthorSmall({ author, description }) {
    return (
        <div className="sidebar-widget sidebar-blog-category">
            <div className="author">
                <div className="sidebar-title">
                    <h4>About {author}</h4>
                </div>
                <div className="author-detalis">
                    <a href="#author" className="author-image"><img style={{ marginTop: `12px` }} src="https://amanojha.pythonanywhere.com/media/Aman_Ojha.jpg" alt="author" className="img-fluid" /></a>
                    <div className="author-info">
                        <a href="#author-name" className="author-name">{author}</a>
                        {/* <a href="#follow" className="btn btn-outline-primary">Follow </a> */}
                    </div>
                </div>
                <p className="mt-2">{description}</p>
            </div>
        </div>
    )
}

export default AuthorSmall
